import React, { FunctionComponent, ReactElement } from "react";
import { useDispatch } from "react-redux";
import Modal from "react-modal";

import { sendDeleteDepartmentRequest } from "src/reducers/groupsAndDepartments/departmentsSlice";

import "./styles.scss";

const closeIcon = require("../../../assets/groupsAndDepartments/close.svg").default;

export type ModalProps = {
  isOpen: boolean;
  onClose: Function;
  focusedID: number | undefined;
  departmentName: string | undefined;
};

export const DeleteDepartmentModal: FunctionComponent<ModalProps> = ({ isOpen, onClose, focusedID, departmentName }): ReactElement => {
  const dispatch = useDispatch();

  const onCloseHandler = () => {
    onClose();
  };

  const onDeleteHandler = () => {
    if (focusedID) {
      dispatch(sendDeleteDepartmentRequest(focusedID));
      onClose();
    }
  };

  return (
    <Modal isOpen={isOpen} className="gad-modal" overlayClassName="gad-modal-overlay">
      <div className="gad-wrapper">
        <div className="gad-header">
          Delete {departmentName}
          <button onClick={onCloseHandler} type="button" className="gad-close-btn">
            <img src={closeIcon} alt="close" />
          </button>
        </div>
        <div className="gad-main">Are you sure you want to delete {departmentName}?</div>
        <div className="gad-footer">
          <button onClick={onCloseHandler} className="gad-cancel-btn" type="button">
            Cancel
          </button>
          <button onClick={onDeleteHandler} className="gad-create-btn" type="submit">
            Delete
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default DeleteDepartmentModal;
